import { Component, OnInit } from '@angular/core';
import { DatePipe } from "@angular/common";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from "@angular/router";
import { SharedService } from "./../../../shared/shared.service";
import { AdminDevoteeService } from './../../services/admin-devotee.service';
import { AdminPrasadOrderService } from './../../services/admin-prasad-order.service';
import { PujaPrasadService } from "./../../../prasad-order/puja-prasad.service";
import { PrasadOrderView } from "./../../../prasad-order/prasad-order";
import { PujaPrasadMaster } from './../../../prasad-order/puja-prasad-master';
import { AdminMobileappService } from '../../services/admin-mobileapp.service';
import { DevoteeDetail } from '../../../Devotee/devotee-detail';
import { PujaPrasadOrderVM } from '../../../prasad-order/puja-prasad-order-vm';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { BookPujaVidhiRequest } from '../../../prasad-order/book-puja-vidhi-request';


@Component({
  selector: 'app-admin-puja-prasad-order',
  templateUrl: './admin-puja-prasad-order.component.html',
  styleUrls: ['./admin-puja-prasad-order.component.css'],
  providers: [AdminDevoteeService, AdminPrasadOrderService, PujaPrasadService, AdminMobileappService]
})
export class AdminPujaPrasadOrderComponent implements OnInit {

  constructor(private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private sharedService: SharedService,
    private activeRoute: ActivatedRoute,
    private adminDevoteeService: AdminDevoteeService,
    private adminPrasadOrderService: AdminPrasadOrderService,
    private pujaPrasadService: PujaPrasadService,
    private adminMobileAppService: AdminMobileappService) { }

  errorMessage: string;
  successMessage: string;
  devoteeDetail: DevoteeDetail;
  poDetail: PrasadOrderView;
  pujaPrasadOrderVM: PujaPrasadOrderVM;
  prasadOrderForm: FormGroup;
  pujaPrasadList: PujaPrasadMaster[] = [];
  previousPOList: any[] = [];
  devoteePujaVidhis: any[] = [];
  pujaVidhiErrors: any[] = [];
  addDevoteePujaVidhi: any = {};
  totalCartAmount: number = 0;
  isNewOrder: boolean = true;
  AdminComment: string = "";

  ngOnInit() {



    this.createPrasadOrderForm();
    this.activeRoute.params.subscribe(params => this.loadPageData(params.devoteeId, params.poNo))

    this.loadPujaPrasadList();
  }

  private loadPageData(devoteeId: number, poNo: number) {

    if (poNo == undefined) {
      this.isNewOrder = true;
      this.loadDevoteeDetails(devoteeId);
      return;
    }
    else {
      this.loadPODetails(devoteeId, poNo);
    }

  }

  private loadPujaPrasadList(): void {
    this.sharedService.showSpinner();
    this.pujaPrasadService.getPujaDetails().subscribe(
      data => {
        this.pujaPrasadList = data;
      },
      err => {
        console.log(err);
        this.sharedService.hideSpinner();
      }
    )
  }

  loadDevoteeDetails(devoteeId: number) {
    console.log(devoteeId);

    this.sharedService.showSpinner();
    this.adminDevoteeService.searchDevotee({ devoteeId: devoteeId }).subscribe(
      data => {
        this.devoteeDetail = data.PageData[0];
        this.addToCart();
        this.loadPreviousPrasadOrders(this.devoteeDetail);
        console.log(data);
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      }
    )
  }

  loadPODetails(devoteeId: number, poNo: number) {


    let prasadOrderRquest = this.adminPrasadOrderService.getPrasadOrderDetails(poNo);
    let devoteeRequest = this.adminDevoteeService.searchDevotee({ devoteeId: devoteeId });
    let localPage = this;

    this.sharedService.showSpinner();
    forkJoin([prasadOrderRquest, devoteeRequest]).subscribe(
      data => {
        localPage.devoteeDetail = data[1].PageData[0];
        localPage.pujaPrasadOrderVM = data[0];
        //this.poDetail
        localPage.devoteePujaVidhis = data[0].PujaVidhis;
        localPage.isNewOrder = false;
        localPage.AdminComment = data[0].AdminTextComment;
        localPage.calculateTotalCartAmount();
        localPage.loadPreviousPrasadOrders(this.devoteeDetail);
      },
      err => {
        localPage.errorMessage = err;
        localPage.sharedService.hideSpinner();
      }
    )




    // this.adminPrasadOrderService.search({ OrderId: poNo }).subscribe(
    //   data => {
    //     this.pujaPrasadOrderVM = data.PrasadOrderVidhis.PageData[0];
    //     this.devoteeDetail =
    //       this.loadPreviousPrasadOrders(this.devoteeDetail);
    //     this.loadPOFormData();

    //     console.log(data);
    //   },
    //   err => {
    //     this.errorMessage = err;
    //     this.sharedService.hideSpinner();
    //   }
    // )
  }

  // loadPOFormData() {
  //   this.prasadOrderForm.controls.PujaPrasadId.setValue(this.pujaPrasadOrderVM.Id);
  //   this.prasadOrderForm.controls.Gotra.setValue(this.pujaPrasadOrderVM.Gotra);
  //   this.prasadOrderForm.controls.OnBehalfOf.setValue(this.pujaPrasadOrderVM.Name);

  //   this.prasadOrderForm.controls.YourWish.setValue(this.pujaPrasadOrderVM.WishTextData);
  //   this.prasadOrderForm.controls.PaymentMode.setValue(this.pujaPrasadOrderVM.PaymentMode);
  // }

  public removeFromCart(pujaPrasad: PujaPrasadMaster): void {
    let index = this.devoteePujaVidhis.indexOf(pujaPrasad);
    if (index >= 0) {
      this.devoteePujaVidhis.splice(index, 1);
      this.calculateTotalCartAmount();
    }
  }

  public addToCart(): void {

    this.devoteePujaVidhis.push({ PujaVidhiId: '', Cost: 0, VidhiDate: '' });

    this.calculateTotalCartAmount();
  }

  public calculateTotalCartAmount() {
    let totalAmount = 0;
    this.devoteePujaVidhis.forEach(x => totalAmount += x.Cost);
    this.totalCartAmount = totalAmount;
  }


  private validatePujaVidhi() {
    this.pujaVidhiErrors = [];
    if (this.devoteePujaVidhis.length == 0) {
      this.pujaVidhiErrors.push("Please add Puja Prasad to cart");
      return false;
    }

    // validate all puja vidhi has vidhi date
    for (let i = 0; i < this.devoteePujaVidhis.length; i++) {
      if (this.devoteePujaVidhis[i].PujaVidhiId == null || this.devoteePujaVidhis[i].PujaVidhiId == "") {
        this.pujaVidhiErrors.push("Please select Puja Vidhi");
      }
      if (this.devoteePujaVidhis[i].Cost == null || this.devoteePujaVidhis[i].Cost == 0) {
        this.pujaVidhiErrors.push("Please select Puja Vidhi Cost for Puja: " + this.getPujaPrasadName(this.devoteePujaVidhis[i].PujaVidhiId));
      }
      if (this.devoteePujaVidhis[i].VidhiDate == undefined || this.devoteePujaVidhis[i].VidhiDate == null || this.devoteePujaVidhis[i].VidhiDate == "") {
        this.pujaVidhiErrors.push("Please select Puja Vidhi Date for Puja: " + this.getPujaPrasadName(this.devoteePujaVidhis[i].PujaVidhiId));
      }
    }

    if (this.pujaVidhiErrors.length > 0) {
      return false;
    }

    return true;
  }

  getPujaPrasadName(pujaPrasadId: number) {
    if (pujaPrasadId == 0 || pujaPrasadId == undefined)
      return "";
    return this.pujaPrasadList.find(x => x.PujaVidhiNo == pujaPrasadId).TypeOfPuja;
  }

  pujaVidhiChange(devoteePujaVidhi: any) {
    if (devoteePujaVidhi.PujaVidhiId == 0 || devoteePujaVidhi.PujaVidhiId == undefined) {
      devoteePujaVidhi.Cost = 0;
    } else {
      devoteePujaVidhi.Cost = this.pujaPrasadList.find(x => x.PujaVidhiNo == devoteePujaVidhi.PujaVidhiId).Amount;
    }
    this.calculateTotalCartAmount();
  }

  updateOrder(): void {

    if (this.AdminComment == null || this.AdminComment == "") {
      this.errorMessage = "Please enter admin comment";
      return;
    }

    let prasadOrderRequest = {
      PrasadOrderId: this.pujaPrasadOrderVM.Id,
      AdminTextComment: this.AdminComment
    }
    this.sharedService.showSpinner();
    this.adminPrasadOrderService.updateOrder(prasadOrderRequest).subscribe(
      data => {
        this.successMessage = "Order updated successfully";
      }
      , err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      }
      , () => this.sharedService.hideSpinner()
    )
  }


  placeOrder(): void {

    if (this.prasadOrderForm.invalid) {
      this.sharedService.validateAllFormFields(this.prasadOrderForm);
      console.log(this.prasadOrderForm.errors);
      return;
    }

    if (!this.validatePujaVidhi()) {
      return;
    }

    let formData = { ...this.prasadOrderForm.value };
    let bookPujaVidhiRequest: BookPujaVidhiRequest = {
      mobileNo: this.devoteeDetail.MobileNo.toString(),
      name: formData.OnBehalfOf,
      gotra: formData.Gotra,
      paymentRemark: formData.PaymentMode,
      wishTextData: formData.YourWish,
      totalCost: this.totalCartAmount,
      prasadQuantity: this.devoteePujaVidhis.length,
      platform: "AdminWebApp",
      pujaVidhis: this.devoteePujaVidhis
    }


    console.log(bookPujaVidhiRequest);

    this.sharedService.showSpinner();
    this.adminPrasadOrderService.save(bookPujaVidhiRequest).subscribe(
      data => {
        this.prasadOrderForm.markAsPristine();
        this.prasadOrderForm.reset();
        this.successMessage = "Order placed successfully";
        this.prasadOrderForm.controls.PaymentMode.setValue("Cash");
        //this.router.navigate(['pujaprasadseva','PaytmSuccess']);   
        this.devoteePujaVidhis = [];
      },
      err => {
        console.log(err);
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }

  getPujaPrasadType(pujaPrasadId: number) {

    if (pujaPrasadId == 0)
      return "";

    return this.pujaPrasadList.find(x => x.Id == pujaPrasadId).TypeOfPuja;
  }


  loadPreviousPrasadOrders(devoteeDetail: DevoteeDetail) {
    this.errorMessage = "";

    let searchGridEntity = {
      PageNumber: 0,
      MobileNo: devoteeDetail.MobileNo,
      FirstName: devoteeDetail.FirstName,
      MiddleName: devoteeDetail.MiddleName,
      LastName: devoteeDetail.LastName,
    };

    this.sharedService.showSpinner();
    this.adminPrasadOrderService.search(searchGridEntity).subscribe(
      data => {
        console.log(data);
        this.previousPOList = data.PrasadOrderVidhis.PageData;
        let poWithGotra = this.previousPOList.find(x => x.OnlinePujaPrasadOrder && x.OnlinePujaPrasadOrder.Gotra);
        if (poWithGotra) {
          this.prasadOrderForm.controls.Gotra.setValue(poWithGotra.OnlinePujaPrasadOrder.Gotra);
        }

      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }

  sendWhatsAppMsgOrderConfirmed(whatsAppMsgRequest: any) {

    this.sharedService.showSpinner();
    this.adminMobileAppService.whatsAppMsgSend(whatsAppMsgRequest).subscribe(
      data => {
        console.log(data);
      },
      err => {
        this.errorMessage = err;
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }


  createPrasadOrderForm(): void {
    this.prasadOrderForm = this.formBuilder.group({
      PujaPrasadId: [0],
      Gotra: [],
      OnBehalfOf: [, Validators.required],
      YourWish: [],
      PaymentMode: ["Cash", Validators.required]
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/components/admin-puja-prasad-order/admin-puja-prasad-order.component.ts